
<template>
  <div
    class="sb-employee-card horizontal"
    :class="layout_classes"
    v-editable="editing && blok"
  >
    <div class="sb-employee-card__inner" v-if="employee">
      <img
        class="sb-employee-card__image"
        :src="employee.content.image.filename + image_compression_portrait"
        :alt="employee.content.image.alt || ''"
      />
      <div class="sb-employee-card__info">
        <h3 class="info__name m-0 font-bold">{{ employee.content.name }}</h3>
        <h3 class="info__title m-0">{{ employee.content.title }}</h3>

        <div class="info__links" v-if="employee.content.info">
          <a
            v-for="(l, k) in employee.content.info"
            :key="k"
            :href="l.link.url"
            class="links__link mb-[0px]"
            :class="'icon-' + l.type"
            >{{ l.label || l.type }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({ blok: Object });
const { getLayoutClasses } = useLayoutControl();
const layout_classes = getLayoutClasses(props.blok);
// const {  } = useConfig();
//  console.log(props.blok)
const storyblokApi = useStoryblokApi();
const { editing,content_version,image_compression_portrait} =  useSettings();
const { locale, locales } = useI18n();
// console.log(props.blok.employee);
let employee = false;
// storyblokApi.
const { data } = await storyblokApi.get("cdn/stories/" + props.blok.employee, {
  find_by: "uuid",
  version: content_version.value,
  //  language: locale.value
});
if (data.story) {
  employee = data.story;
}
</script>
<style lang="scss">
.sb-employee-card {
  .sb-employee-card__image {
    border-radius: 50%;
  }
  &.horizontal {
     margin-bottom: 1rem;
      padding-right:1rem;
     .sb-employee-card__inner {
       display: flex;
       align-items: center;
     }
     .sb-employee-card__image {
  
        width: 120px;
        margin-right: 1rem;
      }
      .sb-employee-card__info {
        h3 {
          font-size: 14px;
          line-height: 1.2em;
        }
        .info__links {
          margin-top: 1rem;
          font-size: 12px;
          .links__link {
            display: block;
          }
        }
      }
   @include breakpoint(lg){
      margin-bottom: 2rem;
      .sb-employee-card__image {
  
        width: 220px;
        margin-right: 2rem;
      }
      .sb-employee-card__info {
        h3 {
          font-size: 32px;
          line-height: 1.2em;
        }
        .info__links {
          margin-top: 1rem;
           font-size: 1rem;
          .links__link {
            display: block;
          }
        }
      }
   }
  }
  //   *:last-child:not(:first-child){
  //      margin-bottom:0px;
  //   }
  //   &.text-center{
  //      text-align: center;
  //   }
}
</style>